import React, { useEffect, useState } from "react";
import { Download, X } from "lucide-react";
import { useI18n } from "@/context/I18nContext";

/**
 * Native PWA install prompt (Android/Chrome/Edge desktop).
 * iOS Safari does not fire beforeinstallprompt; shows a hint only when in Safari.
 */
export default function InstallPrompt() {
  const { t } = useI18n();
  const [deferred, setDeferred] = useState(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (localStorage.getItem("ikh-install-dismissed") === "1") return;
    const onPrompt = (e) => {
      e.preventDefault();
      setDeferred(e);
      setVisible(true);
    };
    window.addEventListener("beforeinstallprompt", onPrompt);
    return () => window.removeEventListener("beforeinstallprompt", onPrompt);
  }, []);

  if (!visible || !deferred) return null;

  const install = async () => {
    deferred.prompt();
    await deferred.userChoice;
    setVisible(false); setDeferred(null);
    localStorage.setItem("ikh-install-dismissed", "1");
  };
  const later = () => {
    setVisible(false);
    localStorage.setItem("ikh-install-dismissed", "1");
  };

  return (
    <div className="fixed bottom-4 left-4 right-4 sm:left-auto sm:right-6 sm:bottom-6 sm:w-80 z-40 rounded-2xl border border-slate-200 dark:border-white/10 bg-white dark:bg-[#121316] shadow-lg p-4 flex items-start gap-3" data-testid="install-prompt">
      <div className="w-10 h-10 shrink-0 rounded-xl bg-blue-50 dark:bg-blue-500/10 text-blue-600 dark:text-blue-400 grid place-items-center">
        <Download size={18} />
      </div>
      <div className="flex-1">
        <p className="text-sm font-medium text-slate-900 dark:text-white">{t("install.prompt")}</p>
        <div className="mt-3 flex items-center gap-2">
          <button onClick={install} data-testid="install-btn" className="px-4 py-1.5 rounded-full bg-blue-600 hover:bg-blue-700 text-white text-xs font-medium transition-colors">{t("install.button")}</button>
          <button onClick={later} className="px-4 py-1.5 rounded-full text-slate-600 dark:text-slate-300 hover:bg-slate-50 dark:hover:bg-white/5 text-xs font-medium transition-colors">{t("install.later")}</button>
        </div>
      </div>
      <button onClick={later} className="text-slate-400 hover:text-slate-600 dark:hover:text-white" aria-label="Close"><X size={16} /></button>
    </div>
  );
}
